import React, { createContext, useCallback, useContext, useState } from "react";

const CartDrawerContext = createContext(null);

export const useCartDrawer = () => {
  const context = useContext(CartDrawerContext);
  if (!context) {
    throw new Error("useCartDrawer must be used within a CartDrawerProvider");
  }
  return context;
};

export const CartDrawerProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openCartDrawer = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeCartDrawer = useCallback(() => {
    setIsOpen(false);
  }, []);

  const value = {
    isCartDrawerOpen: isOpen,
    openCartDrawer,
    closeCartDrawer,
  };

  return (
    <CartDrawerContext.Provider value={value}>
      {children}
    </CartDrawerContext.Provider>
  );
};
